import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  root: {
    marginTop: '24px',
    marginBottom: '24px',
  },
});
export { useStyles };
